<template>
  <div id="app">
    <div v-if="showModalAddStoreImages">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog modal-lg">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">Thay đổi ảnh cửa hàng</h5>
                  <button
                    type="button"
                    @click="closeAddPhuLuc()"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body text-center" style="max-height: 500px; overflow: scroll">
                  <div class="form-group row img-list mr-0 ml-0">
                    <ul v-viewer>
                      <li v-for="(item, index) in dataImg" :key="index">
                        <a href="#popup-slider" data-toggle="modal">
                          <img :src="item.dataURL" />
                          <span @click="removeImg(index)"><i class="bx bx-trash bx-sm"></i></span>
                        </a>
                      </li>
                      <li v-if="dataImg && dataImg.length < 1">
                        <div class="add-img">
                          <span class="bx bx-plus text-center"></span>
                          <input @input="onSelectFile" ref="fileInput" type="file" />
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="modal-footer">
                  <button type="button" @click="closeAddPhuLuc()" class="btn btn-light">
                    Đóng
                  </button>
                  <button
                    @click="submitAdd()"
                    type="button"
                    class="btn btn-primary"
                    :disabled="(dataImg && dataImg.length === 0) || arrayFormData.length === 0"
                  >
                    Cập nhật
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <div id="app">
      <div v-if="showModalErr">
        <transition name="modal">
          <div class="modal-mask">
            <div class="modal-wrapper">
              <div class="modal-dialog">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">Thông báo</h5>
                    <button
                      type="button"
                      class="close"
                      data-dismiss="modal"
                      @click="showModalErr = false"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body text-center">
                    <img src="@/assets/img/noti-unsuccess2.svg" alt="icon-successs" />
                    <h2 class="f18 py-3">{{ messErr }}</h2>
                  </div>
                  <div class="modal-footer">
                    <button
                      type="button"
                      class="btn btn-light"
                      @click="showModalErr = false"
                      data-dismiss="modal"
                    >
                      Bỏ qua
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>

    <div v-if="showLoading">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">Thông báo</h5>
                </div>
                <div class="modal-body text-center">
                  <div class="box-loading d-flex justify-content-center">
                    <div class="loading f20 py-2">
                      <i class="bx bx-loader-circle bx-spin bx-rotate-90 fz50"></i>
                    </div>
                  </div>
                  <h2 class="f18 py-3">{{ messErr }}</h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
  import { CommonService } from '@/services/common.service'
  import { ContractService } from '@/services/contract.service'

  export default {
    props: ['showModalAddStoreImages', 'dataImagesContract', 'dataContract', 'dataIdStores'],

    data() {
      return {
        formData2: new FormData(),
        arrayFormData: [],
        arrayImgInsertSuccess: [],
        dataImg: [],
        showModalErr: false,
        messErr: '',
        dataImageStoreSelected: [],
        dataImageStores: [],
        showLoading: false,
      }
    },

    updated() {
      this.dataImg = this.dataImagesContract
    },

    methods: {
      async onSelectFile() {
        const input = this.$refs.fileInput
        const files = input.files
        const fomatUpload = ['image/jpeg', 'image/png']
        const checkFomat = fomatUpload.includes(input.files[0].type)
        if (!checkFomat) {
          alert('Định dạng ảnh không đúng')
          return
        }

        var FileSize = input.files[0].size / 1024 / 1024 // in MB

        if (FileSize > 2) {
          alert('Size ảnh quá lớn')
          return
        }
        if (this.dataImg.length === 1) {
          alert('Chỉ được up 1 ảnh')
          return
        }
        this.formData2 = new FormData()
        this.formData2.append('files', files[0])
        this.formData2.append('folderName', 'Store')
        this.arrayFormData.push(this.formData2)
        if (files && files[0] && this.dataImg.length < 1) {
          const reader = new FileReader()
          reader.onload = e => {
            this.dataImg.push({ dataURL: e.target.result })
          }
          reader.readAsDataURL(files[0])
          this.$emit('input', files[0])
        }
      },

      async closeAddPhuLuc() {
        this.dataImg = []
        this.arrayFormData = []
        this.$emit('close')
      },

      async submitAdd() {
        try {
          this.showLoading = true
          this.messErr = 'Đang cập nhật ảnh, vui lòng chờ !'
          await this.uploadImg()
          await this.$emit('submitAddImagesStore', { dataImages: this.dataImg })
          this.arrayFormData = []
          this.showLoading = false
          this.closeAddPhuLuc()
          // this.$emit('close')
        } catch (error) {
          console.log(error)
        }
      },

      removeImg(index) {
        this.dataImg.map((e, i) => {
          if (this.dataImg[index].accessKey === e.accessKey) {
            this.dataImg.splice(i, 1)
          }
        })
        this.dataImg.splice(index, 1)
        if (this.dataContract.imageStatus === 'FULL_IMAGE' && this.dataImg.length < 1) {
          this.showModalErr = true
          this.messErr = 'Bạn phải upload một ảnh cho cửa hàng'
        }
      },

      async uploadImg() {
        try {
          this.arrayImgInsertSuccess = []
          for (let index = 0; index < this.arrayFormData.length; index++) {
            const element = this.arrayFormData[index]
            await CommonService.uploadImg(element).then(res => {
              if (res.code === 1000) {
                // const url = `${(window._env_?.VUE_APP_GET_CCRP_CONFIG ?? process.env.VUE_APP_GET_CCRP_CONFIG)}/file/${res.message}`
                this.arrayImgInsertSuccess.push(res.data[0])
                this.saveImages()
              }
            })
          }
        } catch (error) {
          console.log('add img reader', error)
        } finally {
          // this.$emit('successImg', 1)
        }
      },

      async saveImages() {
        try {
          this.transformImage()
          if (this.arrayImgInsertSuccess.length > 0) {
            this.dataImageStoreSelected = this.dataContract.stores.filter(
              e => e.areaId === this.dataIdStores
            )
            this.dataImageStores = this.dataContract.stores.filter(
              e => e.areaId !== this.dataIdStores
            )

            // this.dataImg.shift()
            this.arrayImgInsertSuccess.forEach(imgUrl => {
              this.dataImageStores.push({
                areaId: this.dataImageStoreSelected[0].areaId,
                areaName: this.dataImageStoreSelected[0].areaName,
                areaAddress: this.dataImageStoreSelected[0].areaAddress,
                contractS3URL: imgUrl,
                accessKey: '',
                dataType: 'STORE',
              })
            })
            const body = {
              contractId: this.dataContract.id,
              customerId: this.dataContract.customerId,
              deviceType: 'WEB',
              stores: this.dataImageStores,
              images: this.dataContract.generalImages,
              // groupServiceCode: this.dataContract.groupService
            }
            const response = await ContractService.saveMixFiles(body)
            if (response.result === true || response.success === true) {
              this.$emit('successImg', 1)
            } else {
              this.$emit('errorImg', response.message)
            }
          }
        } catch (error) {
          console.log('add img reader', error)
        } finally {
          // this.$emit('successImg', 1)
        }
      },

      transformImage() {
        this.dataContract.generalImages = this.dataContract.generalImages.map(e => {
          return {
            accessKey: e.accessKey,
            dataType: e.dataType,
            contractS3URL: e.dataURL,
          }
        })
        this.dataContract.stores = this.dataContract.stores.map(e => {
          return {
            accessKey: e.accessKey,
            areaAddress: e.areaAddress,
            areaId: e.areaId,
            areaName: e.areaName,
            dataType: e.dataType,
            contractS3URL: e.dataURL,
          }
        })
      },
    },
  }
</script>

<style scoped>
  .modal-dialog {
    margin-top: 0;
  }
</style>
